<template>
  <span>
    <v-btn
      v-if="type == 'edit'"
      color="primary"
      outline
      :icon="icon"
      small
      :loading="allLoading"
      @click.stop="handleOpenDialog"
    >
      <v-icon small>edit</v-icon>
    </v-btn>
    <v-btn
      v-if="type == 'add'"
      color="primary"
      outline
      :icon="icon"
      :loading="allLoading"
      @click="handleOpenDialog"
      ><v-icon>add</v-icon>Add</v-btn
    >

    <v-dialog v-model="showManage" scrollable persistent max-width="600">
      <template v-if="showManage">
        <TicketEdit
          :value="value"
          :type="type"
          :loading="loading"
          :loading-agent-group="loadingAgentGroup"
          :loading-agent-sub-group="loadingAgentSubGroup"
          :show-close-button="true"
          @onClose="showManage = false"
          @editTicket="$emit('editTicket', $event)"
        ></TicketEdit>
      </template>
    </v-dialog>
  </span>
</template>

<script>
import TicketEdit from './TicketEdit.vue'
export default {
  components: {
    TicketEdit
  },
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'add'
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingAgentGroup: false,
      loadingAgentSubGroup: false,
      loading: false,
      showManage: false
    }
  },
  computed: {
    allLoading() {
      return this.loadingAgentGroup || this.loadingAgentSubGroup || this.loading
    }
  },
  methods: {
    handleOpenDialog() {
      this.showManage = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketEditDialog.vue